import { Button } from '@/common/components/Button'
import { WarningExclamationIcon } from '@/app/common/icons/general'
import { AppRoutePaths } from '@/routing/route_paths'
import { useNavigate } from 'react-router-dom'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { useTranslation } from 'react-i18next'
import { useTypesafeStudent } from './useTypesafeStudent'

export const SubmittedDocument = () => {
  const { t: translate } = useTranslation()
  const navigateTo = useNavigate()
  const { fullName } = useTypesafeStudent()

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Content>
        <section
          className="flex-grow flex flex-col items-center justify-center"
          aria-labelledby="step-title"
          aria-describedby="step-desc"
        >
          <WarningExclamationIcon className="size-12" />
          <h3
            id="step-title"
            className="text-xl font-medium text-gray-900 mt-3"
          >
            {translate('application_being_reviewed')}
          </h3>
          <p id="step-desc" className="text-sm text-center text-gray-900 mt-6">
            {translate('your_student_birth_certificate', {
              student_name: fullName,
            })}
            <br />
            <br />
            {translate('your_student_document_success', {
              student_name: fullName,
            })}
          </p>
        </section>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="flex-col">
        <span className="text-gray-900 mb-2 text-center">
          {translate('can_begin_a_new_application').replace(
            ':student_name',
            fullName
          )}
          .
        </span>
        <Button
          onClick={() => {
            navigateTo(AppRoutePaths.home.index)
          }}
          className="w-full h-9"
        >
          {translate('go_to_home')}
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
